import type { ObjectRelationsMap } from '../../form/DuplicateRelationsForm/DuplicateRelationsForm';
import type {
  ContentTypePropertyConfig,
  RelationWithoutHydration,
} from '../../lib/flotiq-client/types/api-response';

import { isRecord } from '../../lib/helpers';

const getUniqueRelations = (relations: RelationWithoutHydration[]) =>
  Array.from(
    relations.reduce((acc, relation) => {
      acc.set(relation.dataUrl, relation);
      return acc;
    }, new Map<string, RelationWithoutHydration>()),
  ).map(([, relation]) => relation);

export const collectDuplicableRelations = (
  object: Record<string, unknown>,
  properties: Record<string, ContentTypePropertyConfig>,
) => {
  const relations = Object.entries(object).reduce((acc, [key, value]) => {
    if (!value || typeof value !== 'object') return acc;
    if (!Array.isArray(value) || !value.length) return acc;

    if (properties[key]?.inputType === 'object') {
      const fieldRelations = getUniqueRelations(
        value.flatMap((item) => {
          if (!isRecord(item)) {
            return [];
          }

          return Object.values(
            collectDuplicableRelations(
              item,
              properties[key]?.items?.propertiesConfig || {},
            ),
          ).flatMap(({ relations }) => relations);
        }),
      );

      if (fieldRelations.length) {
        acc[key] = {
          relations: fieldRelations,
          fieldLabel: properties[key].label || key,
        };
      }
      return acc;
    }

    if (properties[key]?.inputType !== 'datasource') return acc;

    const withoutMedia = value.filter(
      ({ dataUrl }) => !dataUrl.includes('/api/v1/content/_media'),
    );
    if (!withoutMedia.length) return acc;

    acc[key] = {
      relations: withoutMedia,
      fieldLabel: properties[key].label || key,
    };
    return acc;
  }, {} as ObjectRelationsMap);
  return relations;
};
